var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateGroupGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#template-group-group_svg__clip0_6487_106142)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 10.97l6.97-3.506 6.97 3.506-6.97 3.505L1 10.97z",
    stroke: "#626E85",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9.556L7.97 6.05l6.97 3.506-6.97 3.505L1 9.556z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 7.97l6.97-3.506 6.97 3.506-6.97 3.505L1 7.97z",
    stroke: "#626E85",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6.556L7.97 3.05l6.97 3.506-6.97 3.505L1 6.556z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 4.97l6.97-3.506 6.97 3.506-6.97 3.505L1 4.97z",
    fill: "#fff",
    stroke: "#626E85",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "template-group-group_svg__clip0_6487_106142"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/template-group-group.5c0f8012.svg";
export { SvgTemplateGroupGroup as ReactComponent };